import { AsciiText } from '../framework/AsciiText';
import { ViscaBase } from './util/ViscaBase';
export class ViscaUdp extends ViscaBase {
    constructor(socket, log) {
        super(log);
        this.socket = socket;
        this.log = log;
        this.ipAddress = '';
        this.port = 0;
    }
    onConfigure(config) {
        var _a, _b;
        super.onConfigure(config);
        this.ipAddress = (_a = config.ipAddress) !== null && _a !== void 0 ? _a : '';
        this.port = (_b = config.port) !== null && _b !== void 0 ? _b : 0;
    }
    parser(message) {
        return {
            address: message.address,
            message: message.message.slice(8, message.message.length - 1),
            port: message.port,
        };
    }
    receive(command) {
        return command.slice(8, command.length - 1);
    }
    send(bytes) {
        const sendBytes = [];
        sendBytes.push(1);
        // VISCA responses always have 0x11 as byte 1
        sendBytes.push(0x11);
        sendBytes.push(0);
        sendBytes.push(bytes.length + 1);
        sendBytes.push(0, 0, 0, 0);
        sendBytes.push(...bytes);
        sendBytes.push(0xff);
        this.socket.send(this.ipAddress, this.port, AsciiText.decode(sendBytes));
    }
}
ViscaUdp.emulatorType = 'udpEmulator';
ViscaUdp.key = '-NVept1aZ-gBDJ5mhjaz';
